module.exports = __webpack_public_path__ + "static/media/BBCNews.0784a509.jpg";